import {Divider} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import {Edit, FileCopy, Visibility} from '@material-ui/icons';
import {Roles} from 'app/Constants';
import {LookupProps} from 'components/grid-dx/MasterGrid';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {CreateCoursePopup} from 'features/edit-course/components';
import {i18n2} from 'features/i18n/i18n';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {useDeleteCourse, useLoadCourses} from '../hooks';
import {CloneCoursePopup} from './index';
import IntegrityCourse from './IntegrityCourseGrid';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  getActionColumnWidth,
  useActionButtonStyles,
} from 'components/grid-dx/styles/actionButtonStyles';

const MAX_ACTION_BUTTONS = 2;

export const lookupStatus = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('Editing')},
      {id: 1, name: i18n2._('In progress')},
      {id: 2, name: i18n2._('Valid')},
      {id: 3, name: i18n2._('Obsolete')},
    ],
    key: 'id',
  },
};

const Buttons = (
  e: any,
  setRedirect: React.Dispatch<
    React.SetStateAction<{
      url: string;
      data: {};
    }>
  >,
  setOpenConfirmCloneButton: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      idCourse: number;
      name: string;
      version: number;
      typeCourse: string;
    }>
  >,
) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  const dispatch = useDispatch();

  if (e.data.data.deleted) {
    return null;
  }

  const redirectToCourse = (type: boolean) => {
    dispatch({type: 'SAVE_ID_COURSE', payload: e.data.data.iD_Course});
    setRedirect({
      url: '/Course',
      data: {
        id: e.data.data.iD_Course,
        type: type,
        typeCourse: e.data.data.iD_Type,
      },
    });
  };

  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      {e.data.data.status === 0 && (
        <IconButton
          size="small"
          title={i18n2._('Editar')}
          className={isTablet ? styles.tabletButton : styles.compactButton}
          onClick={() => redirectToCourse(false)}>
          <Edit
            className={isTablet ? styles.tabletIcon : styles.compactButton}
          />
        </IconButton>
      )}
      {e.data.data.status !== 0 && (
        <IconButton
          size="small"
          title={i18n2._('Ver')}
          className={isTablet ? styles.tabletButton : styles.compactButton}
          onClick={() => redirectToCourse(true)}>
          <Visibility
            className={isTablet ? styles.tabletIcon : styles.compactButton}
          />
        </IconButton>
      )}

      <IconButton
        size="small"
        title={i18n2._('Clonar')}
        className={isTablet ? styles.tabletButton : styles.compactButton}
        onClick={() =>
          setOpenConfirmCloneButton({
            open: true,
            idCourse: e.data.data.iD_Course,
            name: e.data.data.name,
            version: e.data.data.version,
            typeCourse: e.data.data.iD_Type,
          })
        }>
        <FileCopy
          className={isTablet ? styles.tabletIcon : styles.compactButton}
        />
      </IconButton>
    </div>
  );
};

const CustomAddPopup = (open: boolean, setOpen: any, refresh: any) => {
  return (
    <CreateCoursePopup
      open={open}
      setOpen={setOpen}
      handleClose={() => setOpen(false)}
      refresh={refresh}
    />
  );
};

const CourseOldGrid = () => {
  const [redirect, setRedirect] = useState({url: '', data: {}});
  const [openConfirmCloneButton, setOpenConfirmCloneButton] = useState({
    open: false,
    idCourse: 0,
    name: '',
    version: 0,
    typeCourse: '',
  });
  const loadCourse = useLoadCourses();
  const removeCourse = useDeleteCourse();
  const isTablet = useIsTablet();

  return redirect.url !== '' ? (
    <Redirect
      to={{
        pathname: redirect.url,
        state: redirect.data,
      }}
    />
  ) : (
    <>
      <h2 className={'TitleGrid'}>{i18n2._('Courses')}</h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <IntegrityRoleGrid
        allowEdit={[
          Roles.AdminHSE,
          Roles.AdminITPS,
          Roles.AdminQA,
          Roles.Trainer,
        ]}
        dataSource={loadCourse}
        exportName="Course-export"
        promiseDelete={removeCourse}
        id={['iD_Course']}
        customEditPopup={true}
        componentAddPopup={CustomAddPopup}
        integrityId={['ID_Course']}
        integrityName={'Course'}
        integrityGrid={IntegrityCourse}>
        <Column
          caption={i18n2._('#Course')}
          dataField="iD_Course"
          width="5%"
          defaultSortOrder={'desc'}
        />
        <Column
          caption={i18n2._('Documento')}
          dataField="doc_Number"
          width="14%"
        />
        <Column caption={i18n2._('Nombre')} dataField="name" width="40%" />
        <Column
          caption={i18n2._('Contenido')}
          dataField="content"
          width="14%"
          visible={false}
        />
        <Column caption={i18n2._('Estado')} dataField="status" width="6%">
          <Lookup
            dataSource={lookupStatus}
            valueExpr="id"
            displayExpr={(item: LookupProps) => {
              return i18n2._(item ? item.name : '');
            }}
          />
        </Column>
        <Column
          caption={i18n2._('Incluir en capacitación inicial')}
          dataField="included_capa_ini"
          visible={true}
        />
        <Column
          caption={i18n2._('Tipo de curso')}
          dataField="iD_Type"
          visible={false}
        />
        <Column
          caption={i18n2._('Compania')}
          visible={false}
          dataField="company"
        />
        <Column
          caption={i18n2._('Fecha de vigencia')}
          dataField="dateVig"
          dataType="date"
          format="dd/MM/yyyy"
          calculateCellValue={(row: any) => new Date(row.dateVig)}
          width="7%"
        />
        <Column
          caption={i18n2._('#Parent')}
          visible={false}
          dataField="iD_Parent"
        />
        <Column
          caption={i18n2._('Version')}
          dataField="version"
          visible={false}
        />
        <Column
          caption={i18n2._('Puntaje')}
          dataField="score"
          visible={false}
        />
        <Column
          caption={i18n2._('Revision')}
          dataField="revision"
          visible={false}
        />
        <Column
          caption={i18n2._('Motivo')}
          dataField="reason"
          visible={false}
        />
        <Column
          caption={i18n2._('Fecha de actualizacion')}
          dataField="updateDate"
          dataType="date"
          format="dd/MM/yyyy"
          calculateCellValue={(row: any) => new Date(row.updateDate)}
          width="8%"
        />
        <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
        <Column
          caption={i18n2._('Eliminado')}
          dataField="deleted"
          width="5%"
          visible={false}
        />
        <Column
          caption=""
          cellComponent={(e: any) =>
            Buttons(e, setRedirect, setOpenConfirmCloneButton)
          }
          width={getActionColumnWidth(MAX_ACTION_BUTTONS, isTablet)}
          fixed
          alignment="right"
        />
      </IntegrityRoleGrid>
      {openConfirmCloneButton.open && (
        <CloneCoursePopup
          open={openConfirmCloneButton.open}
          idCourse={openConfirmCloneButton.idCourse}
          typeCourse={openConfirmCloneButton.typeCourse}
          name={openConfirmCloneButton.name}
          version={openConfirmCloneButton.version}
          handleClose={() =>
            setOpenConfirmCloneButton({
              open: false,
              idCourse: 0,
              name: '',
              typeCourse: '',
              version: 0,
            })
          }
        />
      )}
    </>
  );
};

/// hidingPriority: Te permite ocultar una columna, en la grilla te aparecen "..." y al hacer click te permite visualizar los datos ocultos en un detalle de esa fila.
export default CourseOldGrid;
